export const summaryRows: string[] = [
  'Volume 1 — Industrial Automation Fundamentals',
  'Volume 2 — PLC Systems & Architecture',
  'Volume 3 — PLC Logic & Control Principles',
  'Volume 4 — Sensors, Actuators & Industrial I/O',
  'Volume 5 — HMI, SCADA & Industrial Communication',
  'Volume 6 — PLC Troubleshooting, Maintenance & Advanced Automation',
  'Bonus 1 — 150 Essential Terms Technical Glossary',
  'Bonus 2 — 48 Fault Analysis Scenarios',
  'Bonus 3 — 30 Practical Industrial Scenarios',
  'Bonus 4 — 40 Concept Connections + 4 Integration Maps',
  'Bonus 5 — 36 Safety & Reliability Principles + 6 Scenarios',
  '7-day money-back guarantee',
  'Instant access',
];
